import styled from 'styled-components';

export const Wrapper = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(256px, 512px));
  grid-gap: 8px;
`;
